import React, { useEffect } from 'react';
import { Card, CardActions, CardContent, Typography, Paper, setLocale, numeral, makeStyles } from '../';
import moment from 'moment';
import { Link } from 'react-router-dom';
var useStyles = makeStyles(function (theme) {
  return {
    card: {
      maxWidth: 345,
      textDecoration: 'none',
      'margin-bottom': '10px !important',
      borderRadius: '4px',
      width: '300px'
    },
    footer: {
      display: 'flex',
      justifyContent: 'space-between',
      padding: '0px',
      background: 'white'
    },
    footerLink: {
      display: 'flex',
      justifyContent: 'space-between',
      padding: '0px',
      background: 'white',
      'margin-bottom': '10px !important',
      borderRadius: '0 0 4px 4px'
    },
    paper: {
      padding: '5px'
    },
    contentLink: {
      background: '#424242',
      borderRadius: '4px 4px 0 0',
      'max-width': '300px'
    },
    budget: {
      'margin-left': '15px',
      background: 'inherit',
      color: theme.palette.primary.contrastText
    },
    active: {
      background: theme.palette.primary.main,
      color: theme.palette.primary.contrastText
    },
    activeLink: {
      background: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      borderBottomRightRadius: '4px'
    },
    pending: {
      background: theme.palette.pending.main,
      color: theme.palette.primary.contrastText,
      borderBottomRightRadius: '4px'
    },
    pendingLink: {
      background: theme.palette.pending.main,
      color: theme.palette.primary.contrastText
    },
    overdue: {
      background: theme.palette.error.main,
      color: theme.palette.error.contrastText,
      borderBottomRightRadius: '4px'
    },
    overdueLink: {
      background: theme.palette.error.main,
      color: theme.palette.error.contrastText
    }
  };
});

var SMCard = function SMCard(props) {
  var _props$data = props.data,
      name = _props$data.name,
      client = _props$data.client,
      budget = _props$data.budget,
      date = _props$data.date,
      laneId = _props$data.laneId,
      type = _props$data.type;
  var title = props.title,
      subtitle = props.subtitle,
      left = props.left,
      right = props.right,
      status = props.status,
      taskPipeline = props.taskPipeline,
      onClick = props.onClick,
      locale = props.locale;
  var classes = useStyles();
  var fortmattedDate = moment(date).format('DD/MM/YYYY');
  var diff = moment(date).diff(moment(), 'months');
  useEffect(function () {
    setLocale(locale);
  }, [locale]);
  return props.link ? /*#__PURE__*/React.createElement(Card, {
    "data-cy": name,
    onClick: onClick,
    component: Link,
    to: props.link ? props.link : null,
    className: classes.card
  }, /*#__PURE__*/React.createElement(CardContent, {
    className: classes.contentLink
  }, /*#__PURE__*/React.createElement(Typography, {
    style: {
      'word-break': 'break-word'
    },
    gutterBottom: true,
    variant: title || 'h6',
    component: "h2"
  }, name || type.label), /*#__PURE__*/React.createElement(Typography, {
    style: {
      'word-break': 'break-word'
    },
    variant: subtitle || 'subtitle1',
    color: "textSecondary",
    component: "p"
  }, client && client[0] ? client[0].name : client)), /*#__PURE__*/React.createElement(CardActions, {
    className: classes.footerLink
  }, /*#__PURE__*/React.createElement(Paper, {
    square: true,
    elevation: 0,
    className: [classes.paper, classes.budget].join(' ')
  }, !taskPipeline && /*#__PURE__*/React.createElement(Typography, {
    variant: left || 'subtitle2',
    color: "inherit",
    component: "p"
  }, laneId !== 'tasks' ? numeral(budget).format('0,0[.]00 $') : '')), /*#__PURE__*/React.createElement(Paper, {
    elevation: 0,
    square: true,
    className: [classes.paper, diff > 3 ? classes.activeLink : diff >= 0 && diff <= 3 ? classes.pendingLink : classes.overdueLink // status === 'active' || 'done'
    // 	? classes.activeLink
    // 	: status === 'pending' ? classes.pendingLink : classes.overdueLink
    ]
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: right || 'subtitle1',
    color: "inherit",
    component: "p"
  }, fortmattedDate)))) : /*#__PURE__*/React.createElement(Card, {
    "data-cy": name,
    onClick: onClick,
    className: classes.card
  }, /*#__PURE__*/React.createElement(CardContent, {
    className: classes.content
  }, /*#__PURE__*/React.createElement(Typography, {
    gutterBottom: true,
    variant: title || 'h6',
    component: "h2"
  }, name || type.label), /*#__PURE__*/React.createElement(Typography, {
    variant: subtitle || 'subtitle1',
    color: "textSecondary",
    component: "p"
  }, client)), /*#__PURE__*/React.createElement(CardActions, {
    className: classes.footer
  }, /*#__PURE__*/React.createElement(Paper, {
    square: true,
    elevation: 0,
    className: [classes.paper, classes.budget].join(' ')
  }, !taskPipeline && /*#__PURE__*/React.createElement(Typography, {
    variant: left || 'subtitle2',
    color: "inherit",
    component: "p"
  }, laneId !== 'tasks' ? numeral(budget).format('0,0[.]00 $') : '')), /*#__PURE__*/React.createElement(Paper, {
    elevation: 0,
    square: true,
    className: [classes.paper, status === 'active' || 'done' ? classes.active : status === 'pending' ? classes.pending : classes.overdue].join(' ')
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: right || 'subtitle1',
    color: "inherit",
    component: "p"
  }, fortmattedDate))));
};

SMCard.defaultProps = {
  title: 'h6',
  subtitle: 'subtitle1',
  left: 'subtitle2',
  right: 'subtitle1'
};
export { SMCard };